import { storiesSlider } from "./components/sliders";
import { initFrontAnim, initFrontLineAnim } from "./components/frontAnim";
import initProductRequest from "./components/products";
import initDonationBox from "./components/donationBox";
import initZlickMobilePayment from "./components/zlickMobilePayment";
import initToggles from "./components/toggle";
import initDonationContacts from "./components/toggleDonationContacts";
import initTogglesWithWrapper from "./components/toggleWithWrapper";
import initCopyContent from "./components/copyContent";
import addAccordion from "./components/accordion";
import initAnimateTimeline from "./components/animateTimeline";

function openMenu() {
  function init() {
    const menuBtns = document.querySelectorAll(".mobile-menu-trigger");
    const menu = document.querySelector(".mobile-menu");

    menuBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.classList.toggle("is-active");
        menu.classList.toggle("is-open");
        document.body.classList.toggle("mobile-menu-open");
      });
    });
  }

  const isPresent = document.getElementsByClassName("mobile-menu-trigger");
  if (isPresent.length > 0) {
    init();
  }
}

function submitPaypal() {
  const isPresent = document.querySelector(".js-paypal");
  if (!isPresent) {
    return;
  }

  const paypalButton = document.querySelector(".js-paypal");
  const paypalForm = document.querySelector(".js-paypalForm");

  paypalButton.addEventListener("click", (e) => {
    e.preventDefault();
    paypalForm.submit();
  });
}

function donationBoxLoaded() {
  const isPresent = document.querySelector(".donation-box-inner");
  if (!isPresent) {
    return;
  }

  const box = document.querySelector(".donation-box-inner");

  setTimeout(() => {
    box.classList.add("is-loaded");
  }, 1000);

  setTimeout(() => {
    box.remove();
  }, 2000);
}

document.addEventListener("DOMContentLoaded", () => {
  storiesSlider();

  function initializeAnimations() {
    if (window.innerWidth > 768) {
      initFrontAnim();
      initFrontLineAnim();
    }
  }
  initializeAnimations();
  window.addEventListener("resize", initializeAnimations);

  initProductRequest();
  openMenu();
  initDonationBox();
  initZlickMobilePayment();
  initToggles();
  initDonationContacts();
  initTogglesWithWrapper();
  initCopyContent();
  addAccordion();
  initAnimateTimeline();
  submitPaypal();
  donationBoxLoaded();
});
